import { useState } from 'react';
import { ModalLayout } from '../modal';
import { StyledDiscardButton, StyledDiscardText } from './discard-changes-modal.styles';
import { DiscardChangesModalProps } from './discard-changes-modal.types';
export const DiscardChangesModal = ({
  handleActionButton
}: DiscardChangesModalProps) => {
  const [open, setOpenChange] = useState<boolean>(false);
  const handleAction = () => {
    handleActionButton();
    setOpenChange(false);
  };
  return <ModalLayout open={open} openChange={setOpenChange} triggerElement={<StyledDiscardButton variant="outlined" color="secondary">
          Discard changes
        </StyledDiscardButton>} modalTitleText="Discard Changes" showWarnBox={false} actionButtonText="Discard changes" actionButtonColor="error" closeButtonText="Cancel" handleActionButton={handleAction} data-sentry-element="ModalLayout" data-sentry-component="DiscardChangesModal" data-sentry-source-file="discard-changes-modal.tsx">
      <StyledDiscardText data-sentry-element="StyledDiscardText" data-sentry-source-file="discard-changes-modal.tsx">Are you sure you want to discard all changes?</StyledDiscardText>
    </ModalLayout>;
};